<ng-container *ngIf="visible">
    <app-dialog [title]="dialogTitle" [disabled]="preSelection === null" [template]="buscadorEmpresas" (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #buscadorEmpresas>
        <app-empresadeshidratadora-wrapper
                [mode]="dialogMode" [dialogFilter]="dialogFilter" (selectedEmpresas)="onSelectedEmpresas($event)"></app-empresadeshidratadora-wrapper>
    </ng-template>    
</ng-container>